import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Index.js'
import Navbar from '../../../Components/Navbar/Index.js'
import Subnav from '../../../Components/Navbar/Subnav.js'
import MeetingCard from '../../../Components/Card/MeetingCard.js'
import { SET_MEETINGS, SET_MEETING_BY_ID } from '../../../Actions/Meetings'
import ProfileTrigger from '../../../Components/ProfileTrigger/Index.js'
import Loader from '../../../Components/Loader/Index.js'


class Meetings extends Component {

    constructor() {
        super()
        this.state = {
            meetings: [],
            meetingsLoading: false
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if(!user.token) {
            this.props.history.push('/')
        }

        this.setState({
            meetingsLoading: true
        })

        this.props.actions.SET_MEETINGS().then(meetings => {
            this.setState({meetings})
            this.setState({
                meetingsLoading: false
            })
        })

        document.body.classList.add('has-background');


    }

    componentWillUnmount() {
        document.body.classList.remove('has-background');
    }

    render() {
        const { meetings, meetingsLoading } = this.state
     
        return (
            <>
                <div className="o-page-wrap">
                    
                    <Sidebar />
                    <Navbar />
                    <Subnav />
                    <ProfileTrigger />

                    {
                        (
                            meetingsLoading && (
                                <Loader />
                            )
                        )
                    }

                    <div className="o-main-container o-main-container--spacing">
                        <h1>Meetings</h1>
                        {
                            meetings.length > 0 && (
                                <div className="c-feed">
                                    {
                                        meetings.map((item, i) => 
                                            <MeetingCard 
                                                key={`meeting-wall-${i}`}
                                                users={item.user_count}
                                                date={item.date_for_humans}
                                                end_time={item.endTime}
                                                id={item._id}
                                                title={item.title}
                                                intro={item.intro}
                                                content={item.content}
                                                image={item.image}
                                                address={item.address}
                                            />
                                        )
                                    }

                                </div>
                            )
                        }
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({ SET_MEETINGS, SET_MEETING_BY_ID }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Meetings))